import React, { useEffect } from 'react';
import ContactBreadCumb from '../components/contacts/ContactBreadCumb'
import NewsLetter from '../components/NewsLetter'
import ContactForm from '../components/contacts/ContactForm'


function ContactPage() {
	useEffect(() => {
	  window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);
	
  return (
	  <main>
	  <ContactBreadCumb/>
	  <ContactForm/>
	  <NewsLetter/>
	  
	  </main>

  )
}

export default ContactPage;
